import { TEXT, TEXT_SECONDARY, RULE, ACCENT } from './fleetLocationStyles';

const BOLD = 'TitilliumWeb-Bold';

const scaniaConnectionStyles = {
  default: {
    intro: {
      color: TEXT_SECONDARY,
      fontSize: 15,
      margin: '0 0 16px 0',
      maxWidth: 640,
    },
    addCta: {
      marginTop: 8,
      marginBottom: 16,
      padding: '10px 24px',
      fontSize: 14,
      fontWeight: 700,
      fontFamily: BOLD,
      color: ACCENT,
      background: 'transparent',
      border: `2px solid ${ACCENT}`,
      borderRadius: 50,
      cursor: 'pointer',
    },
    detailsToggle: {
      padding: '4px 14px',
      fontSize: 13,
      fontWeight: 700,
      color: ACCENT,
      background: 'transparent',
      border: `1px solid ${ACCENT}`,
      borderRadius: 50,
      cursor: 'pointer',
      marginBottom: 12,
    },
    overlay: {
      zIndex: 100,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: 560,
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: '90vh',
      overflow: 'hidden',
      padding: 0,
      border: `1px solid ${RULE}`,
      borderRadius: 12,
      background: 'rgba(8, 28, 38, 0.96)',
      color: TEXT,
    },
    dialog: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '90vh',
    },
    header: {
      position: 'relative',
      padding: '24px 48px 8px 24px',
    },
    title: {
      fontFamily: BOLD,
      fontSize: 24,
      color: TEXT,
      margin: 0,
    },
    closeIcon: {
      position: 'absolute',
      top: 16,
      right: 16,
      width: 32,
      height: 32,
      padding: 0,
      border: 'none',
      background: 'transparent',
      color: TEXT,
      fontSize: 22,
      lineHeight: '32px',
      cursor: 'pointer',
    },
    orgLine: {
      color: TEXT_SECONDARY,
      fontSize: 14,
      margin: '8px 0 0 0',
    },
    body: {
      overflowY: 'auto',
      maxHeight: 'calc(90vh - 88px)',
      padding: '8px 24px 24px 24px',
    },
    notice: {
      color: TEXT,
      fontSize: 15,
      background: 'rgba(79, 195, 247, 0.12)',
      borderLeft: `3px solid ${ACCENT}`,
      borderRadius: 4,
      padding: '12px 16px',
      margin: '12px 0',
    },
    noticeTitle: {
      fontFamily: BOLD,
      margin: '0 0 6px 0',
    },
    noticeBody: {
      margin: 0,
      color: TEXT_SECONDARY,
    },
    helpWrap: {
      position: 'relative',
      margin: '8px 0 16px 0',
    },
    helpTrigger: {
      padding: 0,
      border: 'none',
      background: 'transparent',
      color: ACCENT,
      fontSize: 15,
      fontWeight: 700,
      cursor: 'pointer',
    },
    helpPanel: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: '100%',
      marginTop: 8,
      zIndex: 2,
      background: 'rgba(6, 24, 34, 0.98)',
      border: `1px solid ${RULE}`,
      borderRadius: 8,
      padding: '16px 40px 16px 16px',
      color: TEXT,
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
    },
    helpClose: {
      position: 'absolute',
      top: 8,
      right: 8,
      width: 28,
      height: 28,
      border: 'none',
      background: 'transparent',
      color: TEXT,
      cursor: 'pointer',
    },
    helpText: {
      margin: '0 0 8px 0',
      color: TEXT,
      fontSize: 14,
    },
    helpLink: {
      color: ACCENT,
      fontSize: 14,
      fontWeight: 700,
      display: 'inline-block',
      margin: '0 0 12px 0',
    },
    field: {
      display: 'block',
      marginBottom: 16,
    },
    label: {
      display: 'block',
      color: TEXT,
      fontSize: 14,
      fontWeight: 700,
      marginBottom: 6,
    },
    input: {
      width: '100%',
      boxSizing: 'border-box',
      padding: '10px 12px',
      fontSize: 15,
      color: TEXT,
      background: 'rgba(0, 0, 0, 0.25)',
      border: `1px solid ${RULE}`,
      borderRadius: 4,
    },
    secretRow: {
      position: 'relative',
    },
    secretInput: {
      width: '100%',
      boxSizing: 'border-box',
      padding: '10px 44px 10px 12px',
      fontSize: 15,
      color: TEXT,
      background: 'rgba(0, 0, 0, 0.25)',
      border: `1px solid ${RULE}`,
      borderRadius: 4,
    },
    secretToggle: {
      position: 'absolute',
      right: 8,
      top: 8,
      border: 'none',
      background: 'transparent',
      color: TEXT,
      cursor: 'pointer',
      padding: 4,
    },
    helpLine: {
      display: 'block',
      color: TEXT_SECONDARY,
      fontSize: 13,
      marginTop: 6,
    },
    grantNote: {
      color: TEXT_SECONDARY,
      fontSize: 14,
      margin: '8px 0 16px 0',
    },
    error: {
      color: '#FF8A80',
      fontSize: 14,
      margin: '0 0 12px 0',
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 12,
      marginTop: 8,
    },
    button: {
      padding: '10px 24px',
      fontSize: 14,
      fontWeight: 700,
      fontFamily: BOLD,
      color: ACCENT,
      background: 'transparent',
      border: `2px solid ${ACCENT}`,
      borderRadius: 50,
      cursor: 'pointer',
    },
    buttonMuted: {
      padding: '10px 24px',
      fontSize: 14,
      fontWeight: 700,
      fontFamily: BOLD,
      color: TEXT,
      background: 'transparent',
      border: `2px solid ${RULE}`,
      borderRadius: 50,
      cursor: 'pointer',
    },
    buttonDisabled: {
      opacity: 0.5,
      cursor: 'default',
    },
  },
  medium: {
    content: {
      width: '90%',
    },
  },
  small: {
    content: {
      width: '90%',
      maxHeight: '100%',
    },
    body: {
      maxHeight: 'calc(100vh - 88px)',
    },
    title: {
      fontSize: 20,
    },
    actions: {
      flexDirection: 'column-reverse',
    },
  },
};

const modalStyle = {
  default: {
    content: scaniaConnectionStyles.default.content,
    overlay: scaniaConnectionStyles.default.overlay,
  },
  medium: {
    content: scaniaConnectionStyles.medium.content,
  },
  small: {
    content: scaniaConnectionStyles.small.content,
  },
};

export { scaniaConnectionStyles, modalStyle };
